import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { useProfile } from "../../application/hooks/useProfile";
import { ProfileCard } from "../components/ProfileCard";
import { HospitalCard } from "../components/HospitalCard";
import { PermissionsCard } from "../components/PermissionsCard";
import { EditProfileDialog } from "../components/EditProfileDialog";
import { PageShell } from "@/components/layout/PageShell";
import { textStyles } from "@/lib/textStyles";

const ProfilePage = () => {
  const { t } = useTranslation("profile");
  const { profile, loading, error, updateProfile } = useProfile();
  const [openEdit, setOpenEdit] = useState(false);

  const handleSave = async (name: string) => {
    await updateProfile({ name });
    toast.success(t("editDialog.updateSuccess"));
  };

  if (loading) {
    return (
      <PageShell>
        <p className="text-gray-500" style={textStyles.body}>
          {t("loading")}
        </p>
      </PageShell>
    );
  }

  if (error) {
    return (
      <PageShell>
        <p className="text-red-500" style={textStyles.body}>
          {error}
        </p>
      </PageShell>
    );
  }

  if (!profile) return null;

  return (
    <PageShell className="space-y-6">
      <h1 style={textStyles.heading2}>{t("pageTitle")}</h1>

      <ProfileCard profile={profile} onEdit={() => setOpenEdit(true)} />

      <HospitalCard
        hospitalName={profile.hospitalName}
        city={profile.city}
        state={profile.state}
        country={profile.country}
      />

      {profile.permissions.length > 0 && (
        <PermissionsCard permissions={profile.permissions} />
      )}

      <EditProfileDialog
        open={openEdit}
        onOpenChange={setOpenEdit}
        profile={profile}
        onSave={handleSave}
      />
    </PageShell>
  );
};

export default ProfilePage;
